import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import SidebarNav, { SidebarItem } from './SidebarNav.vue';
import Loading from '@/components/atoms/loading/Loading.vue';
import ChevronIcon from '@/icons/ChevronIcon.vue';

export interface SidebarProps {
    items: SidebarItem[];
    initialCollapsed?: boolean;
    active?: string;
    isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    items: null,
    initialCollapsed: { type: Boolean },
    active: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    items: SidebarItem[];
    initialCollapsed?: boolean;
    active?: string;
    isLoading?: boolean;
};


const isCollapsed = ref(props.initialCollapsed || false);

function toggleCollapse() {
    isCollapsed.value = !isCollapsed.value;
}


return { __sfc: true,props, isCollapsed, toggleCollapse, SidebarNav, Loading, ChevronIcon }
}

})